import { Component } from '@angular/core';
import { FashionLoginComponent } from 'gung-standard';

@Component({
    selector: 'sjoborg-fashion-login',
    templateUrl: './sjoborg-fashion-login.component.html',
    styleUrls: ['./sjoborg-fashion-login.component.scss'],
    standalone: false
})
export class SjoborgFashionLoginComponent extends FashionLoginComponent {}
